exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".EmailSignupPage__panels___2QATF {\n  margin-top: 10px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.EmailSignupPage__left___259cC {\n  -webkit-box-flex: 1;\n      -ms-flex: 1;\n          flex: 1;\n  padding-right: 20px;\n  border-right: 1px solid #ddd;\n  margin-right: 20px;\n}\n.EmailSignupPage__right___3XYQy {\n  -webkit-box-flex: 1;\n      -ms-flex: 1;\n          flex: 1;\n  margin-left: 20px;\n}\n.EmailSignupPage__loginText___LjOVY {\n  margin-top: 20px;\n}\n", ""]);
// Exports
exports.locals = {
	"panels": "EmailSignupPage__panels___2QATF",
	"left": "EmailSignupPage__left___259cC",
	"right": "EmailSignupPage__right___3XYQy",
	"loginText": "EmailSignupPage__loginText___LjOVY"
};